var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 300,
    viewBox: "0 0 351 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96936 10C1.96936 4.47716 6.44651 0 11.9694 0H336.07C341.593 0 346.07 4.47715 346.07 10V290C346.07 295.523 341.593 300 336.07 300H11.9694C6.4465 300 1.96936 295.523 1.96936 290V10Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M328.712 180C328.712 180 322.179 105.5 269.446 76.5C216.712 47.5 189.179 56.5 155.579 73C121.979 89.5 109.346 119.26 80.4458 133.5C51.5451 147.74 9.51246 157.5 7.6458 191.5C5.77913 225.5 16.9791 248.5 32.8458 257.5C48.7125 266.5 64.1125 266.5 64.1125 266.5H307.712C307.712 266.5 338.046 250 328.712 180Z",
    fill: "#92E3A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M328.712 180C328.712 180 322.179 105.5 269.446 76.5C216.712 47.5 189.179 56.5 155.579 73C121.979 89.5 109.346 119.26 80.4458 133.5C51.5451 147.74 9.51246 157.5 7.6458 191.5C5.77913 225.5 16.9791 248.5 32.8458 257.5C48.7125 266.5 64.1125 266.5 64.1125 266.5H307.712C307.712 266.5 338.046 250 328.712 180Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1124 64C71.1124 64 71.3318 63.9 71.7611 63.72",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9404 62.865C81.7291 60 104.778 53.125 132.712 60C170.942 69.41 233.139 144.82 286.712 126.5C320.984 114.78 317.316 63.65 279.712 60.21C235.673 56.18 221.925 79.36 218.868 86.165",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.32 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.366 87.3C218.188 87.75 218.112 88 218.112 88",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.282 251.15L218.714 254.26L221.92 254.76L219.601 257.18L220.147 260.6L217.282 258.99L214.412 260.6L214.962 257.18L212.643 254.76L215.849 254.26L217.282 251.15Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.997 251.15L232.43 254.26L235.636 254.76L233.316 257.18L233.862 260.6L230.997 258.99L228.132 260.6L228.678 257.18L226.358 254.76L229.564 254.26L230.997 251.15Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.712 251.15L246.145 254.26L249.351 254.76L247.032 257.18L247.578 260.6L244.712 258.99L241.847 260.6L242.393 257.18L240.074 254.76L243.28 254.26L244.712 251.15Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.428 251.15L259.86 254.26L263.066 254.76L260.747 257.18L261.293 260.6L258.428 258.99L255.562 260.6L256.108 257.18L253.789 254.76L256.995 254.26L258.428 251.15Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.143 251.15L273.576 254.26L276.782 254.76L274.462 257.18L275.008 260.6L272.143 258.99L269.278 260.6L269.824 257.18L267.504 254.76L270.71 254.26L272.143 251.15Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.918 57.245H297.016V83.08H328.918V57.245Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.918 57.245H297.016V61.28H328.918V57.245Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.136 68C309.136 67.3612 308.959 66.7367 308.628 66.2055C308.296 65.6743 307.826 65.2603 307.275 65.0159C306.724 64.7714 306.118 64.7074 305.533 64.8321C304.948 64.9567 304.411 65.2643 303.989 65.716C303.568 66.1678 303.281 66.7433 303.164 67.3698C303.048 67.9964 303.108 68.6459 303.336 69.2361C303.564 69.8263 303.95 70.3307 304.446 70.6856C304.942 71.0406 305.525 71.23 306.121 71.23C306.921 71.23 307.687 70.8897 308.253 70.2839C308.818 69.6782 309.136 68.8566 309.136 68Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.379 73.125H306.886C307.919 73.125 308.909 73.5643 309.638 74.3464C310.368 75.1284 310.778 76.189 310.778 77.295V80.39H301.473V77.295C301.473 76.7461 301.574 76.2026 301.771 75.6957C301.967 75.1888 302.255 74.7285 302.618 74.341C302.981 73.9536 303.412 73.6468 303.885 73.4381C304.359 73.2294 304.867 73.123 305.379 73.125Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.352 66.935H326.906",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.352 70.43H326.906",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.352 73.93H326.906",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.352 77.43H326.906",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3124 229H9.04578V203.5H23.6384L26.3124 207.38V229Z",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6384 203.5V207.38H26.3124",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1431 210.565H22.4484",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1431 214.38H22.4484",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1431 218.2H22.4484",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1431 222.02H22.4484",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5425 55.4056L27.8132 73.5104L37.9845 95.2632L71.7138 77.1585L61.5425 55.4056Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8104 73.51L51.2604 78.54L61.5411 55.405",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9838 95.265L44.7131 77.28",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7098 77.16L54.7231 71.41",
    stroke: "black",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.179 266.5H329.179",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0458 266.5H282.046",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1124 266.5H74.8458",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.312 278C258.88 278 328.246 276.433 328.246 274.5C328.246 272.567 258.88 271 173.312 271C87.745 271 18.379 272.567 18.379 274.5C18.379 276.433 87.745 278 173.312 278Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M282.657 203.12C282.657 203.12 294.958 213.585 300.857 224.49C306.756 235.395 306.56 242.785 306.56 242.785C306.56 242.785 289.186 229.5 285.252 220.5C282.898 215.077 281.999 209.059 282.657 203.12Z",
    fill: "#92E3A9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.639 188.53C334.639 188.53 337.332 207.32 330.878 218.89C324.424 230.46 306.662 242.5 306.662 242.5C306.662 242.5 304.11 234.055 313.42 221.225C322.73 208.395 334.639 188.53 334.639 188.53Z",
    fill: "#92E3A9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M305.729 221.655C305.729 221.655 305.902 207.195 314.278 192.295C322.655 177.395 332.693 162.295 335.05 155.875C336.616 151.434 337.884 146.879 338.844 142.245C338.844 142.245 342.33 154.635 335.806 171.12C329.282 187.605 305.729 221.655 305.729 221.655Z",
    fill: "#92E3A9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.364 215.715C306.364 215.715 296.475 202.24 289.643 186.83C282.811 171.42 283.912 155.42 283.912 155.42C283.912 155.42 296.736 173.23 300.815 187.14C304.894 201.05 306.364 215.715 306.364 215.715Z",
    fill: "#92E3A9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M308.324 185.25C308.324 185.25 310.657 163.11 316.22 150.825C321.782 138.54 333.192 119.555 333.192 119.555C333.192 119.555 334.592 140.81 325.628 157.77C316.663 174.73 308.324 185.25 308.324 185.25Z",
    fill: "#92E3A9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308.781 172.535C308.781 172.535 297.189 154.035 294.025 140.805C290.861 127.575 288.112 105.195 288.112 105.195C288.112 105.195 302.01 120.435 305.407 139.58C308.804 158.725 308.781 172.535 308.781 172.535Z",
    fill: "#92E3A9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303.046 92.69C303.046 92.69 313.928 101.29 312.206 119.345C310.484 137.4 308.823 143.5 308.823 143.5C310.512 131.13 303.046 92.69 303.046 92.69Z",
    fill: "#92E3A9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M306.863 248.525C306.863 248.525 305.846 245.67 305.846 223.89C305.846 202.11 308.51 193.545 308.51 172.125C308.51 150.705 309.845 130.71 309.845 130.71",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M308.389 183.14C308.389 183.14 315.632 166.42 318.698 160.14C321.54 154.33 324.83 144.91 324.83 144.91",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M322.179 190C317.722 198.83 307.563 218.88 305.729 221.665",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324.274 185.825L323.01 188.325",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M295.187 185.69L292.784 179.555",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.878 212.995L296.251 188.415",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M298.276 231.635C296.209 228.88 294.034 225.81 292.21 222.85",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M317.848 226.835C313.023 233.065 305.878 241.065 305.878 241.065C305.878 241.065 303.368 238.19 300.227 234.175",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M321.484 221.655C320.933 222.591 320.336 223.496 319.696 224.365",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M301.935 146.03L300.306 140.145",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M308.389 169.405L302.794 149.155",
    stroke: "#263238",
    strokeWidth: 0.332487,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M292.532 238.11H321.614V249.24H318.87L315.328 273.725H298.813L295.276 249.24H292.532V238.11Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M165.3 240.045C165.3 240.045 170.34 263.265 168.146 267.08C165.276 272.08 134.728 275.08 134.728 275.08H202.092C202.092 275.08 210.534 272.545 207.995 265.27C206.03 259.645 196.608 240.045 196.608 240.045H165.3Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.825 240.045C163.825 240.045 169.201 263.46 166.672 267.08C164.142 270.7 134.728 273.47 134.728 273.47H202.395C202.395 273.47 208.088 271.005 206.506 265.27C204.924 259.535 195.12 240.045 195.12 240.045H163.825Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M195.134 240.045H163.825C163.825 240.045 167.008 253.92 167.32 261.96H205.344C202.269 254.23 195.134 240.045 195.134 240.045Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M202.092 273.59H134.728V275.08H202.092V273.59Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M279.442 79H84.0997C81.9141 79 80.1423 80.8983 80.1423 83.24V238.095C80.1423 240.437 81.9141 242.335 84.0997 242.335H279.442C281.627 242.335 283.399 240.437 283.399 238.095V83.24C283.399 80.8983 281.627 79 279.442 79Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M274.654 79H79.3117C77.1261 79 75.3544 80.8983 75.3544 83.24V238.095C75.3544 240.437 77.1261 242.335 79.3117 242.335H274.654C276.839 242.335 278.611 240.437 278.611 238.095V83.24C278.611 80.8983 276.839 79 274.654 79Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3544 216.945H278.611V238.09C278.611 239.215 278.194 240.293 277.452 241.088C276.71 241.883 275.703 242.33 274.654 242.33H79.3117C78.2622 242.33 77.2556 241.883 76.5134 241.088C75.7713 240.293 75.3544 239.215 75.3544 238.09V216.945Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M180.732 229.64C180.732 228.849 180.513 228.076 180.103 227.418C179.693 226.76 179.11 226.247 178.428 225.944C177.746 225.642 176.995 225.563 176.271 225.717C175.547 225.871 174.881 226.252 174.359 226.812C173.837 227.371 173.482 228.084 173.337 228.86C173.193 229.636 173.267 230.44 173.55 231.171C173.833 231.902 174.311 232.526 174.925 232.966C175.539 233.405 176.261 233.64 176.999 233.64C177.989 233.64 178.939 233.219 179.639 232.468C180.339 231.718 180.732 230.701 180.732 229.64Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M268.386 89.16H85.5743V204.555H268.386V89.16Z",
    fill: "#949494",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M247.498 89.16H151.029V204.555H247.498V89.16Z",
    fill: "#EDEDED",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M195.894 151.95C197.314 151.95 198.466 150.717 198.466 149.195C198.466 147.673 197.314 146.44 195.894 146.44C194.474 146.44 193.323 147.673 193.323 149.195C193.323 150.717 194.474 151.95 195.894 151.95Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M206.824 151.95C208.244 151.95 209.395 150.717 209.395 149.195C209.395 147.673 208.244 146.44 206.824 146.44C205.404 146.44 204.252 147.673 204.252 149.195C204.252 150.717 205.404 151.95 206.824 151.95Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M217.753 151.95C219.173 151.95 220.324 150.717 220.324 149.195C220.324 147.673 219.173 146.44 217.753 146.44C216.333 146.44 215.182 147.673 215.182 149.195C215.182 150.717 216.333 151.95 217.753 151.95Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M228.682 151.95C230.103 151.95 231.254 150.717 231.254 149.195C231.254 147.673 230.103 146.44 228.682 146.44C227.262 146.44 226.111 147.673 226.111 149.195C226.111 150.717 227.262 151.95 228.682 151.95Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M164.455 89.16H105.636V204.555H164.455V89.16Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M247.494 89.16H105.636V129.945H247.494V89.16Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M164.446 89.16H105.636V129.945H164.446V89.16Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M268.386 89.16H263.379V204.555H268.386V89.16Z",
    fill: "#D4D4D4",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M268.386 133H263.379V163H268.386V133Z",
    fill: "#949494",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M268.386 89.16H85.5743V98.49H268.386V89.16Z",
    fill: "#D4D4D4",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M183.089 91.575H99.5977V96.655H183.089V91.575Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M144.463 135.211C150.865 128.351 150.865 117.23 144.463 110.37C138.061 103.511 127.68 103.511 121.278 110.37C114.876 117.23 114.876 128.351 121.278 135.211C127.68 142.071 138.061 142.071 144.463 135.211Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.871 140.355C135.683 140.358 138.447 139.585 140.899 138.112C143.351 136.638 145.408 134.512 146.871 131.94L137.337 129.075L128.718 129.21L120.752 134.59C122.283 136.405 124.153 137.857 126.241 138.85C128.328 139.843 130.587 140.355 132.871 140.355Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M133.272 140.34C133.832 140.327 134.392 140.284 134.948 140.21L134.7 139.12L136.324 135.62L134.322 132.27L131.056 135.885L133.431 138.965L133.272 140.34Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M130.692 140.2L128.386 129.425L120.738 134.59C123.331 137.664 126.858 139.652 130.692 140.2Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.857 131.94L139.974 129.875L138.107 139.435C141.754 138.113 144.851 135.46 146.857 131.94Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M133.86 134.795L129.992 137.915L126.893 129.805L128.634 126.915L138.107 126.4L140.347 129.635L138.504 137.005L133.86 134.795Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M129.422 123.8L130.295 128.95L133.86 134.795L137.136 127.905L136.926 123.555L129.422 123.8Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M136.996 125L136.94 123.85L135.946 123.605L129.413 123.815L130.286 128.965L130.794 129.8C133.552 128.575 135.848 126.275 136.996 125Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M126.403 117.775C126.403 117.775 125.092 116.275 124.919 117.375C124.746 118.475 125.283 120.375 126.104 121.05C126.926 121.725 127.663 120.605 127.663 120.605L126.403 117.775Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138.816 117.1C138.816 117.1 139.978 115.47 140.254 116.54C140.529 117.61 140.17 119.54 139.418 120.325C138.667 121.11 137.827 120.05 137.827 120.05L138.816 117.1Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M126.926 119.32L125.666 116.5C124.658 114.98 123.962 113.249 123.622 111.42C123.024 108.315 124.028 105.725 125.339 104.92C126.076 104.447 126.946 104.269 127.794 104.42C127.794 104.42 128.046 102.595 132.143 101.045C136.24 99.495 140.762 102.265 140.692 103.235C140.622 104.205 139.521 104.625 139.521 104.625C139.521 104.625 142.736 105.9 141.574 107.53C140.858 108.524 139.93 109.32 138.868 109.85C139.1 110.672 139.29 111.506 139.437 112.35C139.6 113.43 138.695 118.065 138.695 118.065L136.469 111.565L129.502 111.945C129.502 111.945 129.091 115.105 128.354 116.23C127.882 117.086 127.619 118.056 127.588 119.05C127.588 119.05 127.308 120.26 126.926 119.32Z",
    fill: "#696969",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M128.167 107.54C128.153 109.487 128.02 111.431 127.77 113.36C127.622 114.432 127.104 115.406 126.319 116.09C126.319 116.09 127.206 120.51 128.33 122.86C129.455 125.21 131.802 127.14 134.154 126.89C136.506 126.64 138.401 123.76 138.625 121.335C138.849 118.91 137.743 109.92 137.743 109.92C137.743 109.92 130.379 111.285 128.167 107.54Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M131.452 121.46C131.452 121.46 132.722 122.63 135.568 121.59",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M128.694 114.6C128.694 114.6 128.839 113.25 130.92 113.135",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M134.252 112.84C134.724 112.631 135.247 112.591 135.742 112.725C136.237 112.859 136.678 113.161 137.001 113.585",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M133.52 115C133.52 115 133.856 117.665 133.87 118C133.884 118.335 134.934 118.39 134.654 119.08C134.374 119.77 133.464 120.5 132.712 120",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M136.273 115.865C136.296 116.365 136.086 116.77 135.806 116.785C135.526 116.8 135.265 116.415 135.242 115.925C135.218 115.435 135.433 115.015 135.708 115C135.984 114.985 136.25 115.375 136.273 115.865Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M130.874 116.39C130.897 116.89 130.682 117.295 130.407 117.31C130.132 117.325 129.866 116.94 129.842 116.445C129.819 115.95 130.034 115.54 130.309 115.525C130.584 115.51 130.846 115.895 130.874 116.39Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M169.579 109.255H222.429",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M169.579 114.59H205.741",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M169.579 123.255H241.441",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M111.465 147.605C112.076 147.605 112.342 147.995 112.342 148.605V149.105C112.342 149.77 112.053 150.105 111.409 150.105H111.026V151.76H110.588V147.56L111.465 147.605ZM111.428 149.73C111.754 149.73 111.894 149.565 111.894 149.165V148.605C111.894 148.225 111.764 148.03 111.428 148.03H111.008V149.73H111.428Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M114.078 149.465V149.885H113.145V151.385H114.321V151.81H112.706V147.61H114.321V148.035H113.112V149.47L114.078 149.465Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M115.572 147.605C116.188 147.605 116.444 147.94 116.444 148.565V148.905C116.444 149.37 116.295 149.655 115.978 149.77C116.337 149.885 116.472 150.195 116.472 150.645V151.3C116.461 151.471 116.486 151.642 116.547 151.8H116.108C116.047 151.642 116.022 151.471 116.034 151.3V150.64C116.034 150.14 115.828 150.015 115.464 150.015H115.156V151.81H114.718V147.61L115.572 147.605ZM115.46 149.605C115.81 149.605 116.015 149.485 116.015 149.03V148.625C116.015 148.25 115.889 148.05 115.548 148.05H115.124V149.605H115.46Z",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M118.6 148.615V148.725H118.19V148.59C118.19 148.21 118.054 147.99 117.723 147.99C117.392 147.99 117.256 148.21 117.256 148.585C117.256 149.525 118.572 149.615 118.572 150.795C118.572 151.43 118.283 151.845 117.686 151.845C117.088 151.845 116.808 151.43 116.808 150.795V150.555H117.214V150.82C117.214 151.2 117.364 151.42 117.681 151.42C117.998 151.42 118.148 151.2 118.148 150.82C118.148 149.885 116.836 149.82 116.836 148.615C116.836 147.965 117.116 147.565 117.704 147.565C118.292 147.565 118.6 148 118.6 148.615Z",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M118.955 148.62C118.955 147.975 119.254 147.565 119.851 147.565C120.448 147.565 120.752 147.975 120.752 148.62V150.79C120.752 151.425 120.458 151.845 119.851 151.845C119.244 151.845 118.955 151.425 118.955 150.79V148.62ZM119.389 150.815C119.389 151.2 119.538 151.42 119.856 151.42C120.173 151.42 120.322 151.2 120.322 150.815V148.595C120.322 148.22 120.173 147.99 119.856 147.99C119.538 147.99 119.389 148.22 119.389 148.595V150.815Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M121.554 151.805H121.162V147.605H121.718L122.623 150.64V147.605H123.01V151.805H122.544L121.54 148.41L121.554 151.805Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M123.902 150.96L123.748 151.805H123.346L124.098 147.605H124.728L125.479 151.805H125.04L124.891 150.96H123.902ZM123.958 150.555H124.83L124.387 148.135L123.958 150.555Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M127.546 147.605C128.162 147.605 128.424 147.995 128.424 148.605V149.105C128.424 149.77 128.134 150.105 127.514 150.105H127.112V151.76H126.674V147.56L127.546 147.605ZM127.514 149.73C127.836 149.73 127.98 149.565 127.98 149.165V148.605C127.98 148.225 127.85 148.03 127.514 148.03H127.112V149.73H127.514Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M129.642 147.605C130.258 147.605 130.514 147.94 130.514 148.565V148.905C130.541 149.088 130.506 149.275 130.417 149.433C130.327 149.592 130.188 149.711 130.024 149.77C130.384 149.885 130.519 150.195 130.519 150.645V151.3C130.506 151.471 130.534 151.643 130.598 151.8H130.132C130.07 151.642 130.045 151.471 130.057 151.3V150.64C130.057 150.14 129.852 150.015 129.488 150.015H129.18V151.81H128.746V147.61L129.642 147.605ZM129.53 149.605C129.875 149.605 130.08 149.485 130.08 149.03V148.625C130.08 148.25 129.954 148.05 129.614 148.05H129.189V149.605H129.53Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M130.939 148.62C130.939 147.975 131.238 147.565 131.835 147.565C132.432 147.565 132.736 147.975 132.736 148.62V150.79C132.736 151.425 132.442 151.845 131.835 151.845C131.228 151.845 130.939 151.425 130.939 150.79V148.62ZM131.373 150.815C131.373 151.2 131.522 151.42 131.84 151.42C132.157 151.42 132.306 151.2 132.306 150.815V148.595C132.306 148.22 132.157 147.99 131.84 147.99C131.522 147.99 131.373 148.22 131.373 148.595V150.815Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49 149.56V150H133.59V151.82H133.151V147.62H134.71V148.045H133.59V149.575L134.49 149.56Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M135.513 147.605V151.805H135.046V147.605H135.513Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M135.942 151.805V147.605H136.376V151.38H137.496V151.805H135.942Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M139.246 149.465V149.885H138.266V151.385H139.442V151.81H137.846V147.61H139.46V148.035H138.266V149.47L139.246 149.465Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M170.326 148.615V148.725H169.91V148.59C169.91 148.21 169.78 147.99 169.444 147.99C169.108 147.99 168.977 148.21 168.977 148.585C168.977 149.525 170.293 149.615 170.293 150.795C170.293 151.43 170.008 151.845 169.411 151.845C168.814 151.845 168.534 151.43 168.534 150.795V150.555H168.94V150.82C168.94 151.2 169.084 151.42 169.406 151.42C169.728 151.42 169.873 151.2 169.873 150.82C169.873 149.885 168.562 149.82 168.562 148.615C168.562 147.965 168.842 147.565 169.43 147.565C170.018 147.565 170.326 148 170.326 148.615Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M171.38 150L171.152 150.415V151.825H170.713V147.625H171.152V149.655L172.192 147.625H172.631L171.642 149.5L172.668 151.785H172.202L171.38 150Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M173.444 147.605V151.805H173.004V147.605H173.444Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M173.891 151.805V147.605H174.325V151.38H175.445V151.805H173.891Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M175.776 151.805V147.605H176.21V151.38H177.33V151.805H175.776Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M179.379 148.615V148.725H178.964V148.59C178.964 148.21 178.828 147.99 178.497 147.99C178.166 147.99 178.03 148.21 178.03 148.585C178.03 149.525 179.346 149.615 179.346 150.795C179.346 151.43 179.062 151.845 178.46 151.845C177.858 151.845 177.582 151.43 177.582 150.795V150.555H177.993V150.82C177.993 151.2 178.138 151.42 178.46 151.42C178.782 151.42 178.926 151.2 178.926 150.82C178.926 149.885 177.62 149.82 177.62 148.615C177.62 147.965 177.9 147.565 178.488 147.565C179.076 147.565 179.379 148 179.379 148.615Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M112.338 179.5V179.875H111.922V179.475C111.922 179.095 111.782 178.87 111.456 178.87C111.129 178.87 110.989 179.095 110.989 179.475V181.695C110.989 182.07 111.134 182.3 111.456 182.3C111.778 182.3 111.922 182.07 111.922 181.695V181.15H112.338V181.65C112.338 182.285 112.058 182.705 111.451 182.705C110.844 182.705 110.574 182.285 110.574 181.65V179.5C110.574 178.865 110.854 178.445 111.451 178.445C112.048 178.445 112.338 178.86 112.338 179.5Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M112.702 179.5C112.702 178.855 112.996 178.445 113.598 178.445C114.2 178.445 114.512 178.85 114.512 179.5V181.67C114.53 181.805 114.52 181.943 114.483 182.074C114.445 182.205 114.381 182.325 114.295 182.426C114.209 182.527 114.103 182.606 113.985 182.657C113.866 182.709 113.739 182.732 113.612 182.725C113.01 182.725 112.716 182.305 112.716 181.67L112.702 179.5ZM113.131 181.695C113.131 182.075 113.285 182.3 113.598 182.3C113.91 182.3 114.064 182.075 114.064 181.695V179.475C114.064 179.095 113.92 178.87 113.598 178.87C113.276 178.87 113.131 179.095 113.131 179.475V181.695Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M115.301 182.68H114.909V178.5H115.446L116.379 181.5V178.5H116.766V182.7H116.3L115.301 179.305V182.68Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M117.779 182.68V178.905H117.056V178.5H118.922V178.925H118.199V182.7L117.779 182.68Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M119.45 181.835L119.296 182.68H118.894L119.646 178.5H120.276L121.027 182.7H120.579L120.43 181.855L119.45 181.835ZM119.506 181.43H120.378L119.935 179.01L119.506 181.43Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M123.094 179.5V179.875H122.679V179.475C122.679 179.095 122.539 178.87 122.212 178.87C121.886 178.87 121.746 179.095 121.746 179.475V181.695C121.746 182.07 121.895 182.3 122.212 182.3C122.53 182.3 122.679 182.07 122.679 181.695V181.15H123.094V181.65C123.094 182.285 122.814 182.705 122.208 182.705C121.601 182.705 121.33 182.285 121.33 181.65V179.5C121.33 178.865 121.61 178.445 122.208 178.445C122.805 178.445 123.094 178.86 123.094 179.5Z",
    fill: "#263238"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M124.056 182.68V178.905H123.337V178.5H125.204V178.925H124.485V182.7L124.056 182.68Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M169.672 182.68H169.07L168.534 178.48H168.963L169.43 182.055L169.864 178.485H170.298L170.727 182.06L171.17 178.48H171.548L171.021 182.68H170.442L170.069 179.83L169.672 182.68Z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M171.861 179.5C171.861 178.855 172.16 178.445 172.757 178.445C173.354 178.445 173.658 178.855 173.658 179.5V181.67C173.658 182.305 173.364 182.725 172.757 182.725C172.15 182.725 171.861 182.305 171.861 181.67V179.5ZM172.295 181.695C172.295 182.075 172.444 182.3 172.762 182.3C173.079 182.3 173.228 182.075 173.228 181.695V179.475C173.228 179.095 173.079 178.87 172.762 178.87C172.444 178.87 172.295 179.095 172.295 179.475V181.695Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M174.946 178.5C175.562 178.5 175.818 178.835 175.818 179.46V179.8C175.818 180.265 175.669 180.55 175.352 180.665C175.711 180.78 175.846 181.09 175.846 181.54V182.195C175.835 182.366 175.86 182.537 175.921 182.695H175.482C175.421 182.537 175.395 182.366 175.408 182.195V181.5C175.408 181.025 175.202 180.875 174.838 180.875H174.53V182.67H174.092V178.5H174.946ZM174.834 180.5C175.184 180.5 175.389 180.38 175.389 179.925V179.5C175.389 179.125 175.258 178.925 174.922 178.925H174.498V180.48L174.834 180.5Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M176.948 180.855L176.714 181.27V182.68H176.28V178.5H176.714V180.5L177.76 178.47H178.198L177.209 180.385L178.231 182.67H177.764L176.948 180.855Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M180.83 180.34V180.76H179.874V182.26H181.05V182.685H179.44V178.5H181.05V178.925H179.874V180.36L180.83 180.34Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M182.426 180.865L181.773 182.68H181.358L182.146 180.515L181.409 178.5H181.876L182.482 180.18L183.094 178.5H183.5L182.753 180.5L183.537 182.665H183.07L182.426 180.865Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M184.746 178.5C185.362 178.5 185.628 178.89 185.628 179.525V180.025C185.628 180.69 185.334 181.025 184.694 181.025H184.307V182.68H183.873V178.5H184.746ZM184.713 180.625C185.04 180.625 185.18 180.46 185.18 180.06V179.5C185.18 179.12 185.054 178.925 184.713 178.925H184.293V180.625H184.713Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M187.364 180.34V180.76H186.402V182.26H187.578V182.685H185.968V178.5H187.578V178.925H186.402V180.36L187.364 180.34Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M188.857 178.5C189.473 178.5 189.73 178.835 189.73 179.46V179.8C189.73 180.265 189.58 180.55 189.263 180.665C189.622 180.78 189.753 181.09 189.753 181.54V182.195C189.74 182.366 189.768 182.538 189.832 182.695H189.389C189.332 182.536 189.308 182.365 189.319 182.195V181.5C189.319 181.025 189.109 180.875 188.745 180.875H188.437V182.67H188.003V178.5H188.857ZM188.745 180.5C189.09 180.5 189.3 180.38 189.3 179.925V179.5C189.3 179.125 189.17 178.925 188.834 178.925H188.404V180.48L188.745 180.5Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M190.627 178.5V182.7H190.192V178.5H190.627Z",
    fill: "#263238"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M192.469 180.34V180.76H191.512V182.26H192.688V182.685H191.074V178.5H192.688V178.925H191.512V180.36L192.469 180.34Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M193.477 182.68H193.085V178.5H193.64L194.546 181.5V178.5H194.933V182.7H194.466L193.463 179.305L193.477 182.68Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M197.112 179.5V179.875H196.697V179.475C196.697 179.095 196.557 178.87 196.23 178.87C195.904 178.87 195.764 179.095 195.764 179.475V181.695C195.764 182.07 195.908 182.3 196.23 182.3C196.552 182.3 196.697 182.07 196.697 181.695V181.15H197.112V181.65C197.112 182.285 196.832 182.705 196.226 182.705C195.619 182.705 195.348 182.285 195.348 181.65V179.5C195.348 178.865 195.628 178.445 196.226 178.445C196.823 178.445 197.112 178.86 197.112 179.5Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M198.904 180.34V180.76H197.971V182.26H199.142V182.685H197.532V178.5H199.142V178.925H197.971V180.36L198.904 180.34Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M168.986 158.05H237.955",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M168.986 163.945H237.955",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M168.986 169.845H237.955",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M110.06 158.05H158.304",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M110.06 163.945H158.304",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M110.06 169.845H158.304",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M168.986 187.19H237.955",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M168.986 193.085H237.955",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M168.986 198.985H237.955",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M110.06 187.19H158.304",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M110.06 193.085H158.304",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M110.06 198.985H158.304",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9791 184.5L29.3971 266.88C29.3971 266.88 23.0971 272.755 23.6478 275.125C24.1984 277.495 31.4784 273.74 32.4818 271.76C33.4851 269.78 33.9891 266.63 33.9891 266.63L52.0911 204.695L66.0071 271.14C66.0071 271.14 71.9571 276.345 75.2377 276.165C78.5184 275.985 77.3564 274.605 75.4804 272.065C73.6044 269.525 69.3717 268.065 69.3717 268.065L67.2857 182.435L37.9791 184.5Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9777 185.205L37.811 185.365L37.8997 182.555L66.777 180.985L66.9777 185.205Z",
    fill: "#696969",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4884 182.47H50.7611V185.125H55.4884V182.47Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8684 140.375L40.009 143.785L41.3577 182.66L66.8237 181.98L63.6037 141.795L50.8684 140.375Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1177 140.81L44.657 207.155L31.6697 203.15L36.9103 179.025L32.7663 143.65L46.1177 140.81Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9384 185.42L43.8684 186.585L43.5931 187.75L36.8031 186.295",
    fill: "#92E3A9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9384 185.42L43.8684 186.585L43.5931 187.75L36.8031 186.295",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1177 140.81L40.6624 141.97L45.287 178.645L46.1177 140.81Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M48.885 148.235L51.0363 152L49.3143 178.175L53.4023 183.355L55.5163 177.13L52.245 152.05L54.2657 148.415L51.3303 144.345L48.885 148.235Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1124 140.21L64.8404 206.06L74.9671 202.89L69.8898 177.23L70.6644 141.59L57.1124 140.21Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6364 185.275L64.2478 186.875L64.1124 187.895L70.7718 186.15",
    fill: "#92E3A9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6364 185.275L64.2478 186.875L64.1124 187.895L70.7718 186.15",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1678 174.75L61.5318 178.575L61.5271 140.66L57.1124 140.21L61.1678 174.75Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M51.545 147.74L47.4804 151.015L44.223 142.5L46.057 139.46L56.0064 138.92L58.363 142.315L56.4264 150.06L51.545 147.74Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8877 136.185L47.8024 141.6L51.545 147.74L54.9844 140.505L54.7697 135.935L46.8877 136.185Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8537 137.7L54.821 136.96L51.195 136.045L46.8877 136.185L47.821 141.6L48.7964 143.2C48.9175 143.154 49.0359 143.101 49.151 143.04C51.433 141.805 53.8457 138.95 54.8537 137.7Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7664 143.65L14.3237 167.565L26.5737 183.115L31.5111 179.675L25.4537 166.43L34.4977 159.42L32.7664 143.65Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4584 166.43L20.675 163.745",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M31.511 179.675L32.253 181.395L28.095 183.91L27.535 182.535L31.511 179.675Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M32.253 181.395L36.481 187.335L35.081 189.17L34.0684 188.7L32.0197 190.57C32.0197 190.57 30.517 190.125 30.3304 189.605C30.1437 189.085 28.1044 187.79 28.0624 186.91C28.0204 186.03 28.0624 183.91 28.0624 183.91L32.253 181.395Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9357 146.255C80.9357 146.255 81.4024 144.9 81.0944 144.065C80.7864 143.23 80.1237 140.325 80.2544 139.37C80.3851 138.415 81.7337 137.015 81.8551 135.775C81.9764 134.535 81.8317 133.405 81.8877 132.735C81.9437 132.065 82.7137 131.555 83.3717 132.37C84.0297 133.185 84.4264 134.02 84.1137 134.87C83.8011 135.72 83.8104 137.83 83.8104 137.83C83.8104 137.83 84.8557 139.385 85.4391 140.395C86.0224 141.405 85.9664 144.065 85.5744 145.13C85.2113 145.922 84.7017 146.626 84.0764 147.2L84.1417 149.04L80.9357 146.255Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8537 136.385C82.8537 136.385 82.387 137.83 83.2037 138.165C84.0204 138.5 87.315 138.985 87.3524 137.845C87.3897 136.705 87.4457 136.135 86.9184 136.16C86.391 136.185 83.9084 136.16 83.9084 136.16C83.9084 136.16 82.779 136.105 82.8537 136.385Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2457 143.5C83.2457 143.5 82.9144 144.58 83.5024 144.83C84.0904 145.08 86.4611 145.445 86.4844 144.595C86.5077 143.745 86.5544 143.325 86.1717 143.345C85.7891 143.365 84.0017 143.345 84.0017 143.345C84.0017 143.345 83.1571 143.27 83.2457 143.5Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7791 141.195C82.7791 141.195 82.3964 142.44 83.0731 142.73C83.7497 143.02 86.5031 143.445 86.5311 142.465C86.5591 141.485 86.6104 140.965 86.1671 141.01C85.7237 141.055 83.6564 140.985 83.6564 140.985C83.6564 140.985 82.7044 140.955 82.7791 141.195Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5364 138.96C82.5364 138.96 82.0698 140.41 82.8864 140.745C83.7031 141.08 86.9978 141.565 87.0304 140.425C87.0631 139.285 87.1284 138.71 86.5964 138.74C86.0644 138.77 83.5864 138.74 83.5864 138.74C83.5864 138.74 82.4338 138.68 82.5364 138.96Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5624 147.7L81.0757 145.49L84.6364 147.76L84.039 150.165L80.5624 147.7Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6458 141.59L77.4684 157.135L80.8191 147.135L84.0858 150.48L80.7258 169.035C80.6076 169.59 80.3448 170.097 79.9679 170.497C79.591 170.898 79.1156 171.175 78.5971 171.297C78.0786 171.42 77.5384 171.381 77.0394 171.187C76.5405 170.993 76.1034 170.65 75.7791 170.2L70.3191 162.05L70.6458 141.59Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4871 157.135L75.5737 161.965",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4684 155.125L73.7911 166.755L70.3191 162.05L70.4684 155.125Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7097 129.86C43.7097 129.86 42.3097 128.285 42.151 129.44C41.9924 130.595 42.5384 132.585 43.397 133.3C44.2557 134.015 45.035 132.83 45.035 132.83L43.7097 129.86Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M56.753 129.15C56.753 129.15 57.971 127.435 58.265 128.56C58.559 129.685 58.1764 131.735 57.3877 132.56C56.599 133.385 55.717 132.27 55.717 132.27L56.753 129.15Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2604 131.5L42.935 128.5C41.8748 126.905 41.1401 125.089 40.779 123.17C40.149 119.91 41.2037 117.17 42.585 116.35C43.363 115.862 44.2774 115.684 45.1657 115.85C45.1657 115.85 45.427 113.935 49.7297 112.305C54.0324 110.675 58.7877 113.59 58.7177 114.605C58.6477 115.62 57.4857 116.07 57.4857 116.07C57.4857 116.07 60.8644 117.405 59.6417 119.12C58.8882 120.163 57.9141 120.999 56.7997 121.56C57.0434 122.424 57.2428 123.302 57.397 124.19C57.5697 125.32 56.6177 130.19 56.6177 130.19L54.2844 123.345L46.9624 123.74C46.9624 123.74 46.5284 127.065 45.7584 128.24C45.2722 129.136 45.0042 130.149 44.979 131.185C44.979 131.185 44.6617 132.47 44.2604 131.5Z",
    fill: "#696969",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5671 119.105C45.5508 121.149 45.4105 123.19 45.1471 125.215C44.9907 126.342 44.4484 127.367 43.6257 128.09C43.6257 128.09 44.5591 132.73 45.7397 135.2C46.9204 137.67 49.3844 139.7 51.8577 139.435C54.3311 139.17 56.3191 136.15 56.5524 133.6C56.7857 131.05 55.6191 121.6 55.6191 121.6C55.6191 121.6 47.8817 123.04 45.5671 119.105Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0157 133.73C49.0157 133.73 50.3551 134.96 53.3417 133.87",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2157 128.635C46.2157 128.635 47.6157 127.735 48.843 128.49",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1177 126.5C46.1177 126.5 46.2717 125.08 48.451 124.965",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M51.979 124.675C52.476 124.455 53.0258 124.413 53.5469 124.554C54.0681 124.696 54.5328 125.013 54.8723 125.46",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1858 126.95C51.1858 126.95 51.5404 129.755 51.5544 130.105C51.5684 130.455 52.6744 130.515 52.3804 131.24C52.0864 131.965 51.1298 132.74 50.3364 132.17",
    stroke: "#263238",
    strokeWidth: 0.443317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0837 127.85C54.0837 128.35 53.8831 128.805 53.5797 128.82C53.2764 128.835 53.0151 128.43 52.9871 127.91C52.9591 127.39 53.1877 126.96 53.4911 126.945C53.7944 126.93 54.0604 127.335 54.0837 127.85Z",
    fill: "#263238"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeBuilding);
export default __webpack_public_path__ + "static/media/resumeBuilding.3a4b026a9d0ce4b8b9db238c17ad0ab5.svg";
export { ForwardRef as ReactComponent };